// https://developer.mozilla.org/en-US/docs/Web/API/Storage
// Wraps all methods in a try/catch.
// Useful for non-critical storage, and when swallowing errors is acceptable.
// Reasons why localStorage might fail:
// * Simply referencing window.localStorage (fuck brave & safari)
// * localStorage can be null
// * Storage quota exceeded

const methods = ['key', 'getItem', 'setItem', 'removeItem', 'clear']
const idgafLocalStorage = {}

for (const m of methods) {
    idgafLocalStorage[m] = (...args) => {
        try {
            return window.localStorage[m](...args)
        } catch {}
    }
}

export default idgafLocalStorage
